var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"ods-footer",style:({ height: _vm.height }),attrs:{"data-name":"OdsFooter"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }